import { observable } from 'mobx';
import {
  FaultSubmitRequest,
  PopWindowsObj,
  SubmitParams,
} from '@/interface/services/problemAssistant';
import FAULT_SCENE from '@/pages/problem-assistant/const';
import { AlipayCallback } from '@/interface/base';
import { alipayCallNative } from '@hb/bridge-core';
import Api from '@/services/problemAssistant';
import Toast from '@/components/toast';
import TIANQI from '@/pages/problem-assistant/tianqi';

export default class ProblemAssistant {
  @observable public openNotGoPopup = false;

  @observable public notResolveCode = '';

  @observable public notResolveCategory: number | null = null;

  @observable public notResolveAlias = '';

  @observable public notResolveStatus: number | null = null;

  @observable public popWindows: PopWindowsObj = {};

  @observable public showReportRes = false;

  @observable public refresh = true;

  public showReportResPopup = (popWindows: PopWindowsObj) => {
    this.popWindows = popWindows;
    this.showReportRes = true;
  };

  public chooseImage = async () => {
    try {
      const res: AlipayCallback = await alipayCallNative({
        classMap: 'Native',
        command: 'chooseImage',
        data: {
          count: 1,
          sourceType: ['camera'],
        },
      });

      return res.data;
    } catch (e) {
      return [];
    }
  };

  public upLoad = async (imgs: Array<string> = []) => {
    if (imgs && imgs[0]) {
      const res: AlipayCallback = await alipayCallNative({
        command: 'uploadFile',
        classMap: 'Native',
        dataArray: [imgs[0], { image: 1, type: 4 }],
      });

      return res.data.url;
    }
    return '';
  };

  public submitFault = async (
    {
      rideGuid,
      scene,
      faultCodes,
      categorys,
      fastReport,
      lat,
      lng,
    }: FaultSubmitRequest,
    status: number | null,
    alias: string | null,
  ) => {
    if (status === FAULT_SCENE.ONLY_IMG) {
      const businessInfo = {
        order_id: rideGuid,
        problem_type: alias,
      };
      TIANQI.takePhotoPageView(businessInfo);
      const imgs = await this.chooseImage();
      TIANQI.takePhotoSubmit(businessInfo);
      TIANQI.takePhotoPageViewOut(businessInfo);

      if (imgs && imgs.length) {
        const url = await this.upLoad(imgs);
        this.handleSubmit({
          rideGuid,
          scene,
          faultCodes,
          categorys,
          fastReport,
          lat,
          lng,
          url,
        });
      }
    } else {
      this.handleSubmit({
        rideGuid,
        scene,
        faultCodes,
        categorys,
        fastReport,
        lat,
        lng,
      });
    }
  };

  public handleSubmit = async ({
    rideGuid,
    scene,
    faultCodes,
    categorys,
    fastReport,
    lat,
    lng,
    url,
  }: SubmitParams) => {
    try {
      const params: FaultSubmitRequest = {
        rideGuid,
        scene,
        faultCodes,
        categorys,
        fastReport,
        lat,
        lng,
      };
      if (url) {
        params.images = [url];
      }
      const res = await Api.faultSubmit(params);
      this.refresh = true;
      if (res.popWindows) {
        this.showReportResPopup(res.popWindows);
      } else {
        Toast.show(res.hint);
      }
    } catch (e) {
      Toast.showError(e);
    }
  };
}
